import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap-v5";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import HsCodeAdditionalService from "../../Services/HsCodeAdditionalService";
import { EditHsCodeAdditionalFees } from "./EditHsCodeAdditionalFees";
import { AddHsCodeAdditionalFees } from "./AddHsCodeAdditionalFees";
import { FaEdit } from "react-icons/fa";
import { locationServices } from "../../Services";

export const HsCodeAdditionalFees = () => {
  const [show, setShow] = useState(false);
  const [addmodalshow, setAddmodalshow] = useState(false);
  const [item, setItem] = useState(null);
  const [loader, setLoader] = useState(true);
  const [adChargesHeader, setAdChargesHeader] = useState([]);
  const [adCharges, setAdCharges] = useState([]);
  const [countryList, setCountryList] = useState([]);

  const handleClose = () => setShow(false);
  const handleAddmodalclose = () => setAddmodalshow(false);

  const getData = () => {
    setLoader(true);
    HsCodeAdditionalService.getHscodeadditionalfees().then((res) => {
      if (res.status) {
        let data = res.data;
        let sheet_data = [["HS Code"], [""]];
        for (let i = 0; i < data.length; i++) {
          sheet_data[0].push(data[i].country_name);
          sheet_data[0].push("");
          sheet_data[1].push("Charge");
        }

        let hsCodes = Array.from(
          new Set(data.flatMap((item) => item.data.map((dt) => dt.hs_code)))
        );

        let hsCodeDetails = {};
        data.forEach((country) => {
          country.data.forEach((item) => {
            hsCodeDetails[`${item.hs_code}_${country.country_name}`] = {
              _id: item._id,
              hs_code: item.hs_code,
              country_name: country.country_name,
              additional_charge: item.additional_charge,
            };
          });
        });

        hsCodes.forEach((hsCode) => {
          let row = [hsCode];
          data.forEach((country) => {
            let key = `${hsCode}_${country.country_name}`;
            let detail = hsCodeDetails[key];
            row.push(detail ? (
              <>
                {/* {detail.additional_charge || "-"}{" "} */}
                {detail?.additional_charge ?? "-"}
                <FaEdit
                  className="pointer ms-1"
                  onClick={() => {
                    setItem(detail);
                    setShow(true);
                  }}
                  variant="warning"
                  // color="#0323fe"
                  size="18px"
                  style={{ cursor: "pointer" }}
                />
              </>
            ) : "-");
          });
          sheet_data.push(row);
        });

        setAdCharges(sheet_data.slice(2));
        setAdChargesHeader(sheet_data.slice(0, 2));
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const getCountryList = () => {

    locationServices.getCountry().then((res) => {
      if (res.status) {
        let arry = [];
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name, data: list });
        });
        setCountryList(arry);
      } else {
        toast.error(res.message);
      }
    });
  };

  useEffect(() => {
    getCountryList();
  }, []);

  return (
    <div className="container-fluid">
      <div className="white_box h-100">
        <div className="card p-2 h-100">
          <div className="card-body">
            {loader && <Loader isShow={loader} />}
            <div className="d-flex justify-content-end mb-3">
              <button
                // className="btn btn-primary btn-sm w-sm waves-effect waves-light col-1"
                className="btn btn-primary w-sm waves-effect waves-light"
                // onClick={() => history.push("/add-hs-code-additional-fees")}
                onClick={() => setAddmodalshow(true)}
              >
                Add
              </button>
            </div>
            <div className="table-responsive">
              {adChargesHeader.length > 0 && adCharges.length > 0 ? (
                <table className="table table-centered table-nowrap mb-0 border text-center">
                  <thead className="table-light">
                    {adChargesHeader.map((itm, index) => (
                      <tr key={index}>
                        {itm.map((item, i) => {
                          if (i === 0 && index === 0) {
                            return (
                              <th rowSpan={2} key={i}>
                                {item || "-"}
                              </th>
                            );
                          } else if (index === 0) {
                            return item ? <th key={i}>{item || "-"}</th> : null;
                          } else {
                            return item ? <th key={i}>{item || "-"}</th> : null;
                          }
                        })}
                      </tr>
                    ))}
                  </thead>
                  <tbody>
                    {adCharges.map((itm, index) => (
                      <tr key={index}>
                        {itm.map((item, i) => (
                          <td key={i}>{item}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="w-10 text-center mt-2">Data Not Available</div>
              )}
            </div>
          </div>
        </div>

{/* Edit----------------------------------------------------------------------------- */}

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton className="pt-2 pb-0">
            <Modal.Title>
              <h5>Edit HS Code Additional Fees</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {item && (
              <EditHsCodeAdditionalFees
                item={item}
                setShow={setShow}
                getData={getData}
              />
            )}
          </Modal.Body>
        </Modal>

{/* add----------------------------------------------------------------------------- */}
        <Modal show={addmodalshow} onHide={handleAddmodalclose}>
          <Modal.Header closeButton className="pt-2 pb-0">
            <Modal.Title>
              <h5>Add HS Code Additional Fees</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* {item && (
              <EditHsCodeAdditionalFees
                item={item}
                setShow={setShow}
                getData={getData}
              />
            )} */}
            <AddHsCodeAdditionalFees setAddmodalshow={setAddmodalshow}
                getData={getData} countryList={countryList} setCountryList={setCountryList}/>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};
